<script lang="ts" setup>
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import ProductSpecificationForm from '@/components/features/productSpecification/ProductSpecificationForm.vue'
import { useProductSpecificationForm } from '@/composables/useProductSpecificationForm'
import { useRouter } from 'vue-router'
import {editProduct} from '@/api/products'
import type { ErrorResponse } from '@/types/error-types'

const { values, handleSubmit, setErrors, showToast, formType, meta, loading } =
  useProductSpecificationForm('edit')

const productSpecificationId = useRouter().currentRoute.value.params.id as string

const router = useRouter()

const onSubmit =  async () => {
  loading.value = true

  const formData = {
    finishedReference: values.finishedReference || '',
    unfinishedReference: values.unfinishedReference || '',
    alternateReference: values.alternateReference || '',
    displayedReference: values.displayedReference || '',
    colour: values.colour || '',
    finish: values.finish || '',
    fabricWidthValue: values.fabricWidthValue || 0,
    fabricWidthUnit: values.fabricWidthUnit || 0,
    fabricYieldValue: values.fabricYieldValue || 0,
    fabricYieldUnit: values.fabricYieldUnit || 0,
    averageRollLengthValue: values.averageRollLengthValue || 0,
    averageRollLengthUnit: values.averageRollLengthUnit || 0,
    construction: values.construction || '',
    fabricWeight: values.fabricWeight || 0,
    fabricStatus: values.fabricStatus || 0,
    guage: values.guage || '',
    standardBatchSize: values.standardBatchSize || 1,
    fibreContent: values.fibreContent || '',
    productCosts: values.productCosts || [],
    merges: values.merges || [],
    yarnsUsed: values.yarnsUsed || []
  }

  await editProduct(formData, productSpecificationId)
    .then(() => {
      loading.value = false
      showToast('info', 'Product Edited!', 'You have successfully edited product.')
      router.push('/productSpecification')
    })
      .catch((error: { response?: { data: ErrorResponse } }) => {
        loading.value = false
        const errorMessages = error.response?.data?.errors?.map((err) => err.description).join('\n') || 'Unable to edit product.'
        showToast('error', 'An error occurred!', errorMessages)
      })
}
</script>

<template>
  <PageHeader
    title="Edit Product Specification"
    buttonText="Save Changes"
    buttonIcon="basil:edit-solid"
    :buttonClick="onSubmit"
    :buttonDisabled="!meta.dirty"
  />

  <TabView class="bg-white rounded-md pb-2">
    <TabPanel header="Product Specification Details">
      <ProductSpecificationForm
        :type="formType"
        :values="values"
        :onSubmit="onSubmit"
        :setErrors="setErrors"
      />
    </TabPanel>
  </TabView>
</template>